import { Expose, Type } from 'class-transformer';
import { BaseEntity } from './base.entity';
import { SiloEntity } from './silo.entity';

export class SiloListEntity extends BaseEntity {
  @Expose()
  @Type(() => SiloEntity)
  public silos: SiloEntity[];
}
